module.exports = __webpack_public_path__ + "img/illustration-paper.721e0e5a.svg";